import { FAMILY_NAME_GIVEN_NAME_ORDERING_INDEXED_BY_LANGUAGE } from './constants.mjs';
import { languageFromLocale } from './utilities/languageFromLocale.mjs';

function formatName({
  name,
  locale,
  options
}) {
  if (!name.givenName) {
    return name.familyName || '';
  }

  if (!name.familyName) {
    return name.givenName;
  }

  const isFullName = Boolean(options && options.full);
  const customNameFormatter = FAMILY_NAME_GIVEN_NAME_ORDERING_INDEXED_BY_LANGUAGE.get(languageFromLocale(locale));

  if (customNameFormatter) {
    return customNameFormatter(name.givenName, name.familyName, isFullName);
  }

  if (isFullName) {
    return `${name.givenName} ${name.familyName}`;
  }

  return name.givenName;
}

export { formatName };
